import { forwardRef, type InputHTMLAttributes } from 'react';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  hint?: string;
  error?: string;
};

export const Input = forwardRef<HTMLInputElement, Props>(
  ({ label, hint, error, className = '', id, ...props }, ref) => {
    const inputId = id ?? props.name;
    return (
      <div className="space-y-1.5">
        {label && (
          <label htmlFor={inputId} className="block text-sm font-medium text-ink-primary">
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={`block h-10 w-full rounded-lg border border-line bg-surface-white px-3 text-sm text-ink-primary placeholder:text-ink-muted focus:border-bit2me focus:outline-none focus:ring-1 focus:ring-bit2me ${className}`}
          {...props}
        />
        {hint && !error && <p className="text-xs text-ink-tertiary">{hint}</p>}
        {error && <p className="text-xs text-bad">{error}</p>}
      </div>
    );
  },
);
Input.displayName = 'Input';
